import { MapSubtype, MapSubtypeId, MapType, MapTypeId, PerfData, ScaleId } from '../types'

export const EXPANDED_MAP_BODY_CLASSS = 'is-map-expanded'
export const FALLBACK_PERF_RESPONSE: PerfData = { nodes: {}, additional: {}, subtype: MapSubtypeId.DayPerf, hash: '' }

export const MAP_SUBTYPES_COMPANIES_BY_ID: Record<string, MapSubtype> = {
  [MapSubtypeId.DayPerf]: {
    id: MapSubtypeId.DayPerf,
    name: '1 Day Performance',
    scaleId: ScaleId.DayPerf,
    tooltip:
      "Color indicates today's stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.WeekPerf]: {
    id: MapSubtypeId.WeekPerf,
    name: '1 Week Performance',
    scaleId: ScaleId.WeekPerf,
    tooltip:
      'Color indicates weekly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.MonthPerf]: {
    id: MapSubtypeId.MonthPerf,
    name: '1 Month Performance',
    scaleId: ScaleId.MonthPerf,
    tooltip:
      'Color indicates monthly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.ThreeMonthPerf]: {
    id: MapSubtypeId.ThreeMonthPerf,
    name: '3 Months Performance',
    scaleId: ScaleId.ThreeMonthPerf,
    tooltip:
      'Color indicates quarterly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.SixMonthPerf]: {
    id: MapSubtypeId.SixMonthPerf,
    name: '6 Months Performance',
    scaleId: ScaleId.SixMonthPerf,
    tooltip:
      'Color indicates half-yearly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.YearPerf]: {
    id: MapSubtypeId.YearPerf,
    name: '1 Year Performance',
    scaleId: ScaleId.YearPerf,
    tooltip:
      'Color indicates yearly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.YearToDatePerf]: {
    id: MapSubtypeId.YearToDatePerf,
    name: 'Year To Date Performance',
    scaleId: ScaleId.YearPerf,
    tooltip:
      'Color indicates year to date stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.RelativeVolume]: {
    id: MapSubtypeId.RelativeVolume,
    name: 'Relative Volume',
    scaleId: ScaleId.RelativeVolume,
    tooltip:
      "Color indicates the stock's relative volume, ratio between today's and average volume. Values above 1.5 show strong volume, values below 0.5 indicate weak volume.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.PriceToEarnings]: {
    id: MapSubtypeId.PriceToEarnings,
    name: 'P/E',
    scaleId: ScaleId.PriceToEarnings,
    tooltip: "Color indicates the stock's price-to-earnings ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.ForwardPriceToEearnings]: {
    id: MapSubtypeId.ForwardPriceToEearnings,
    name: 'Forward P/E',
    scaleId: ScaleId.ForwardPriceToEearnings,
    tooltip: "Color indicates the stock's forward price-to-earnings ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.PriceEarningsToGrowth]: {
    id: MapSubtypeId.PriceEarningsToGrowth,
    name: 'PEG',
    scaleId: ScaleId.PriceEarningsToGrowth,
    tooltip: "Color indicates the stock's price-to-earnings-to-growth ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.PriceToSellsRatio]: {
    id: MapSubtypeId.PriceToSellsRatio,
    name: 'P/S',
    scaleId: ScaleId.PriceToSellsRatio,
    tooltip: "Color indicates the stock's price-to-sales ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.PriceToBookRatio]: {
    id: MapSubtypeId.PriceToBookRatio,
    name: 'P/B',
    scaleId: ScaleId.PriceToBookRatio,
    tooltip: "Color indicates the stock's price-to-book ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.DividendYield]: {
    id: MapSubtypeId.DividendYield,
    name: 'Dividend Yield',
    scaleId: ScaleId.DividendYield,
    tooltip: "Color indicates the stock's dividend yield.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EPSGrowth5y]: {
    id: MapSubtypeId.EPSGrowth5y,
    name: 'EPS Growth Past 5 Years',
    scaleId: ScaleId.EPSGrowth5y,
    tooltip: "Color indicates the stock's annual earnings (EPS) growth over past 5 years.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.FloatShort]: {
    id: MapSubtypeId.FloatShort,
    name: 'Float Short',
    scaleId: ScaleId.FloatShort,
    tooltip: "Color indicates percent of the stock's float sold short.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.AnalystRecommendation]: {
    id: MapSubtypeId.AnalystRecommendation,
    name: 'Analysts Recom.',
    scaleId: ScaleId.AnalystRecommendation,
    tooltip:
      "Color indicates the analyst's recommendations for given stocks. The rating is based on a 1-5 scale, ranging from a strong-buy, to a strong-sell.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EarningsPerf]: {
    id: MapSubtypeId.EarningsPerf,
    name: 'Earnings Day Performance',
    scaleId: ScaleId.MonthPerf,
    tooltip:
      "Color indicates stock's performance on earnings day. Next day performance for earnings reported after market close.",
    countIndustryPerf: false,
    countSectorPerf: false,
  },
  [MapSubtypeId.EarningsDate]: {
    id: MapSubtypeId.EarningsDate,
    name: 'Earnings Date',
    scaleId: ScaleId.EarningsDate,
    tooltip: "Color indicates stock's earnings date.",
    countIndustryPerf: false,
    countSectorPerf: false,
  },
}

export const MAP_SUBTYPES_ETF_BY_ID = {
  [MapSubtypeId.DayPerf]: {
    id: MapSubtypeId.DayPerf,
    name: '1 Day Performance',
    scaleId: ScaleId.DayPerf,
    tooltip:
      "Color indicates today's stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.WeekPerf]: {
    id: MapSubtypeId.WeekPerf,
    name: '1 Week Performance',
    scaleId: ScaleId.WeekPerf,
    tooltip:
      'Color indicates weekly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.MonthPerf]: {
    id: MapSubtypeId.MonthPerf,
    name: '1 Month Performance',
    scaleId: ScaleId.MonthPerf,
    tooltip:
      'Color indicates monthly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.ThreeMonthPerf]: {
    id: MapSubtypeId.ThreeMonthPerf,
    name: '3 Months Performance',
    scaleId: ScaleId.ThreeMonthPerf,
    tooltip:
      'Color indicates quarterly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.SixMonthPerf]: {
    id: MapSubtypeId.SixMonthPerf,
    name: '6 Months Performance',
    scaleId: ScaleId.SixMonthPerf,
    tooltip:
      'Color indicates half-yearly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.YearPerf]: {
    id: MapSubtypeId.YearPerf,
    name: '1 Year Performance',
    scaleId: ScaleId.YearPerf,
    tooltip:
      'Color indicates yearly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.YearToDatePerf]: {
    id: MapSubtypeId.YearToDatePerf,
    name: 'Year To Date Performance',
    scaleId: ScaleId.YearPerf,
    tooltip:
      'Color indicates year to date stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.RelativeVolume]: {
    id: MapSubtypeId.RelativeVolume,
    name: 'Relative Volume',
    scaleId: ScaleId.RelativeVolume,
    tooltip:
      "Color indicates the stock's relative volume, ratio between today's and average volume. Values above 1.5 show strong volume, values below 0.5 indicate weak volume.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
}

export const MAP_SUBTYPES_COMPANIES: MapSubtype[] = Object.values(MAP_SUBTYPES_COMPANIES_BY_ID)

export const MAP_SUBTYPES_ETF: MapSubtype[] = Object.values(MAP_SUBTYPES_ETF_BY_ID)

export const MAP_TYPES: MapType[] = [
  {
    name: 'S&P 500',
    pageTitle: 'S&P 500 Map',
    description:
      "Standard and Poor's 500 index stocks categorized by sectors and industries. Size represents market cap.",
    type: MapTypeId.Sector,
    subtypes: MAP_SUBTYPES_COMPANIES,
  },
  {
    name: 'World',
    pageTitle: 'World Map',
    description:
      'Foreign ADR stocks listed on NYSE, NASDAQ, AMEX categorized by geo location. Size represents market cap.',
    type: MapTypeId.World,
    subtypes: MAP_SUBTYPES_COMPANIES,
  },
  {
    name: 'Full',
    pageTitle: 'Stock Market Map',
    description:
      'All stocks listed on US stock exchanges, categorized by sectors and industries. Size represents market cap.',
    type: MapTypeId.SectorFull,
    subtypes: MAP_SUBTYPES_COMPANIES,
  },
  {
    name: 'Exchange Traded Funds',
    pageTitle: 'ETF Map - Exchange Traded Funds Map',
    nameShort: 'ETF',
    description: 'ETFs categorized by sectors and styles. Size represents 3-month average dollar volume, $1M minimum.',
    type: MapTypeId.ETF,
    subtypes: MAP_SUBTYPES_ETF,
  },
]

export const MAP_TYPE_SCREENER = {
  name: 'Screener',
  pageTitle: 'Screener Map',
  description:
    'All stocks listed on US stock exchanges, categorized by sectors and industries. Size represents market cap.',
  type: MapTypeId.Screener,
  subtypes: MAP_SUBTYPES_COMPANIES,
}

export const MAP_TYPE_ETF_HOLDINGS_WIDGET = {
  name: 'ETF Holdings',
  pageTitle: '',
  description: '',
  type: MapTypeId.ETFHoldings,
  subtypes: MAP_SUBTYPES_COMPANIES,
}
